import { createRoute } from '@tanstack/react-router'

import { areaRoute } from '@/app/routes/area-layout'
import { lazyPage } from '@/lib/lazy-page'

export const Integrations = lazyPage(
  () => import('./features/integrations/integrations.lazy'),
  'Integrations',
)

export const ApiConnections = lazyPage(
  () => import('./features/api-connections/api-connections.lazy'),
  'ApiConnections',
)

export const integrationsRoute = createRoute({
  getParentRoute: () => areaRoute('settings'),
  path: 'integrations',
  component: Integrations,
  staticData: { title: 'Integrations' },
})

export const apiConnectionsRoute = createRoute({
  getParentRoute: () => areaRoute('settings'),
  path: 'integrations/api-connections',
  component: ApiConnections,
  staticData: { title: 'API connections' },
})
